/*
 *
 * ChooseFileDialog
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 15-May-2025
*/

import { connect } from 'react-redux'
import { nullSafe } from 'Utility/globalMethods'
import ChooseFileDialog from './ChooseFileDialog'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = dispatch => ({
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = state => ({
  data: nullSafe(() => state.popup.popupInfo, {})
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ChooseFileDialog)
